import _reduce from 'lodash/reduce';
import _each from 'lodash/each';
import _debounce from 'lodash/debounce';
import _intersection from 'lodash/intersection';
import _difference from 'lodash/difference';
const baseClass = 'WideGridFilter';
const classes = {
	bar: `${baseClass}-bar`,
	filterButton: `${baseClass}-bar-filterButton-button`,
	filterButtonActive: `${baseClass}-bar-filterButton-button--active`,
	allFilters: `${baseClass}-bar-allFilters`,
	allFiltersButton: `${baseClass}-bar-allFilters-button`,
	item: `${baseClass}-item`,
	itemFiltered: `${baseClass}-item--filtered`,
	hideItem: {
		sm: `${baseClass}-item--hide--sm`,
		md: `${baseClass}-item--hide--md`,
		lg: `${baseClass}-item--hide--lg`,
		xl: `${baseClass}-item--hide--xl`,
	},
	loadMoreButton: `${baseClass}-button`,
	filterCheckbox: `${baseClass}-filter-checkbox`,
	modal: `${baseClass}-modal`,
	viewMoreSectionButton: `${baseClass}-modal-section-viewMoreButton`,
	resultCountText: `${baseClass}-bar-resultCount-text`,
	noResultsContainer: `${baseClass}-noResults-container`,
	checkBoxGroup: `${baseClass}-modal-section-checkboxGroup`,
	checkBoxGroupCheckbox: `${baseClass}-filter-checkboxGroup-checkbox`,
	checkBoxGroupDropdown: `${baseClass}-filter-checkboxGroup-dropdown`,
	checkBoxGroupCheckboxContainer: `${baseClass}-modal-section-checkboxGroup-container`,
	checkBoxGroupOpen: `${baseClass}-filter-checkboxGroup--open`,
	filterSectionContainer: `${baseClass}-modal-section-itemContainer`,
};
const selectors = {
	filterComponent: `.${baseClass}`,
	filterResultsContainer: `.${baseClass}-results`,
	bar: `.${classes.bar}`,
	filterButton: `.${classes.filterButton}`,
	filterButtonActive: `.${classes.filterButtonActive}`,
	allFiltersButton: `.${classes.allFiltersButton}`,
	numFiltersText: `.${classes.allFilters}-numFilters span`,
	item: `.${classes.item}`,
	itemFiltered: `.${classes.itemFiltered}`,
	hideItem: {
		sm: `.${classes.hideItem.sm}`,
		md: `.${classes.hideItem.md}`,
		lg: `.${classes.hideItem.lg}`,
		xl: `.${classes.hideItem.xl}`,
	},
	loadMoreButton: `.${classes.loadMoreButton}`,
	filterCheckbox: `.${classes.filterCheckbox}`,
	filterCheckboxInput: `.${classes.filterCheckbox} input`,
	filterCheckboxInputChecked: `.${classes.filterCheckbox} input:checked`,
	modal: `.${classes.modal}`,
	modalClose: '[data-modal-close]',
	viewMoreSectionButton: `.${classes.viewMoreSectionButton} button`,
	resultCountText: `.${classes.resultCountText}`,
	noResultsContainer: `.${classes.noResultsContainer}`,
	checkBoxGroup: `.${classes.checkBoxGroup}`,
	checkBoxGroupCheckbox: `.${classes.checkBoxGroupCheckbox}`,
	checkBoxGroupDropdownCarot: `.${classes.checkBoxGroupDropdown}-carot-touchpoint`,
	checkBoxGroupCheckboxInput: `.${classes.checkBoxGroupCheckbox} input`,
	checkBoxGroupCheckboxContainer: `.${classes.checkBoxGroupCheckboxContainer}`,
	filterSectionContainer: `.${classes.filterSectionContainer}`,
};

const breakpoints = {
	sm: 0,
	md: 754,
	lg: 1320,
	xl: 1740,
};

let initialRowsToShow = 4;
let initialItemsToShow;
let orEverything = false;

const parseItemColWidths = itemClass => {
	return _reduce(
		Object.keys(breakpoints),
		(agg, bp) => {
			let colWidths = itemClass.match(new RegExp(`wide-grid-item-${bp}-([0-9]+)`))?.[1];
			if (!colWidths) {
				if (bp === 'xl') {
					colWidths = agg[lg] || agg[md] || agg[sm];
				} else if (bp === 'lg') {
					colWidths = agg[md] || agg[sm];
				} else if (bp === 'md') {
					colWidths = agg[sm];
				} else {
					colWidths = 1;
				}
			}
			agg[bp] = parseInt(colWidths);
			return agg;
		},
		{}
	);
};

const gridItemsPerRow = { sm: 2, md: 2, lg: 3, xl: 4 };
const getNumberOfItemsToShow = ($filterComponent, $items, rowsToShow, itemsToShow) => {
	let allSizeItemsToShow = {
		sm: itemsToShow || 0,
		md: itemsToShow || 0,
		lg: itemsToShow || 0,
		xl: itemsToShow || 0,
	};
	if (itemsToShow) {
		$items.each((index, item) => {
			if (index < itemsToShow) {
				$(item).removeClass([
					classes.hideItem.sm,
					classes.hideItem.md,
					classes.hideItem.lg,
					classes.hideItem.xl,
				]);
			}
		});
	} else {
		//rowsToShow should be TOTAL not just the next set (ie if showing 4 rows and want the next 4, we want this to be 8)
		let remainingWidths = {
			sm: rowsToShow * gridItemsPerRow.sm,
			md: rowsToShow * gridItemsPerRow.md,
			lg: rowsToShow * gridItemsPerRow.lg,
			xl: rowsToShow * gridItemsPerRow.xl,
		};

		$items.each((index, item) => {
			//calculate the items to show
			_each(gridItemsPerRow, (itemsPerRow, size) => {
				if (remainingWidths[size] > 0) {
					let currentRowWidthsAvailable = remainingWidths[size] % itemsPerRow;
					let currentItemGridWidths = Math.min(
						parseItemColWidths(item.className)[size] || 1,
						itemsPerRow
					);
					remainingWidths[size] -=
						currentItemGridWidths +
						(currentItemGridWidths > currentRowWidthsAvailable
							? currentRowWidthsAvailable
							: 0);
					//then add to the number of items to show if it doesn't cause us to go into a new row on the last one
					if (remainingWidths[size] >= 0) {
						allSizeItemsToShow[size] += 1;
						$(item).removeClass(classes.hideItem[size]);
					}
				}
			});
		});
	}
	//if we're now showing all items, hide the load more button
	toggleloadMoreButton($items, $filterComponent.find(selectors.loadMoreButton));
	return allSizeItemsToShow;
};

const resetResults = ($filterComponent, $items, rowsToShow, itemsToShow) => {
	$items.addClass(
		`${classes.hideItem.sm} ${classes.hideItem.md} ${classes.hideItem.lg} ${classes.hideItem.xl}`
	);
	getNumberOfItemsToShow($filterComponent, $items, rowsToShow, itemsToShow);
};

const toggleloadMoreButton = ($items, $button) => {
	if ($items.length !== $items.filter(':visible').length) {
		$button.removeClass('hide');
	} else {
		$button.addClass('hide');
	}
};

const setupLoadMore = $filterComponent => {
	const $filterResultsContainer = $filterComponent.find(selectors.filterResultsContainer);
	const loadMoreInitialRowsShowing = (initialRowsToShow =
		$filterResultsContainer.data('rowsShowing'));
	const loadMoreAdditionalRows = $filterResultsContainer.data('additionalRows');

	const loadMoreInitialItemsShowing = (initialItemsToShow =
		$filterResultsContainer.data('itemsShowing'));
	const loadMoreAdditionalItems = $filterResultsContainer.data('additionalItems');

	const loadMoreRows = () => {
		let $items = $filterComponent.find(selectors.item).not(selectors.itemFiltered);
		if (loadMoreInitialItemsShowing) {
			let currentItemsShowing =
				$filterResultsContainer.data('itemsShowing') || loadMoreInitialRowsShowing;
			currentItemsShowing += loadMoreAdditionalItems;
			getNumberOfItemsToShow($filterComponent, $items, null, currentItemsShowing);
			$filterResultsContainer.data('itemsShowing', currentItemsShowing);
		} else {
			let currentRowsShowing =
				$filterResultsContainer.data('rowsShowing') || loadMoreInitialRowsShowing;
			currentRowsShowing += loadMoreAdditionalRows;
			getNumberOfItemsToShow($filterComponent, $items, currentRowsShowing);
			$filterResultsContainer.data('rowsShowing', currentRowsShowing);
		}
	};

	const $button = $filterComponent.find(selectors.loadMoreButton);
	if ($button.length > 0) {
		toggleloadMoreButton(
			$filterComponent.find(selectors.item).not(selectors.itemFiltered),
			$button
		);
		$button.on('click', e => {
			e.preventDefault();
			loadMoreRows();
		});
	} else {
		$(window).on('scroll', e => {
			const containerBottom =
				$filterResultsContainer.offset().top + $filterResultsContainer.height();
			const screenBottom = $(window).scrollTop() + $(window).height();
			if (screenBottom >= containerBottom) {
				loadMoreRows();
			}
		});
	}
};

const setupOnResize = $filterComponent => {
	const $button = $filterComponent.find(selectors.loadMoreButton);
	$(window).on(
		'resize',
		_debounce(() => {
			//check if we need the load more button back or hide it now
			const $items = $filterComponent.find(selectors.item).not(selectors.itemFiltered);
			toggleloadMoreButton($items, $button);

			if (
				$filterComponent.find('.WideGridFilter-bar-filterDropdown-button--selected')
					.length > 0
			) {
				if ($(window).innerWidth() < 961) {
					$('body').css('overflow', 'hidden');
				} else {
					$('body').css('overflow', '');
				}
			}
		}, 100)
	);
};

//Begin Filter Logic Helpers
//****************************************************************************************************************** */

const getActiveFiltersArray = $filterComponent =>
	$filterComponent
		.find(selectors.filterCheckboxInputChecked)
		.map((i, checkbox) => {
			return $(checkbox).attr('id');
		})
		.toArray();

const getItemsToHide = ($filterComponent, $allItems) => {
	if (orEverything) {
		const activeFilters = getActiveFiltersArray($filterComponent);
		return activeFilters.length === 0
			? $()
			: $allItems.filter((i, item) => {
					const itemTags = $(item).data('filters');
					let allMatches = _intersection(itemTags.split(','), activeFilters);
					return allMatches.length === 0;
			  });
	} else {
		const $sections = $filterComponent.find(selectors.filterSectionContainer);
		const orGroups = [];
		$sections.each((i, section) => {
			const activeSectionFilters = getActiveFiltersArray($(section));
			if (activeSectionFilters.length > 0) {
				orGroups.push(activeSectionFilters);
			}
		});

		return $allItems.filter((i, item) => {
			let noMatchFound = false;
			orGroups.forEach(group => {
				const itemTags = $(item).data('filters');
				let allMatches = _intersection(itemTags.split(','), group);
				if (allMatches.length === 0) {
					noMatchFound = true;
					return;
				}
			});
			return noMatchFound;
		});
	}
};

const triggerFilters = $filterComponent => {
	const activeFilters = getActiveFiltersArray($filterComponent.find(selectors.modal));
	const $allItems = $filterComponent.find(selectors.item);
	const $itemsToHide = getItemsToHide($filterComponent, $allItems);
	const $resultCount = $filterComponent.find(selectors.resultCountText);
	const numResults = $allItems.length - $itemsToHide.length;
	const resultTextTemplate = $resultCount.data('resultCountText');
	$resultCount.text(
		(numResults === 1 ? resultTextTemplate.singular : resultTextTemplate.multiple).replace(
			'{0}',
			numResults
		)
	);
	$allItems.removeClass(classes.itemFiltered);
	$itemsToHide.each((i, item) => {
		$(item).addClass(classes.itemFiltered);
	});
	let $items = $filterComponent.find(selectors.item).not(selectors.itemFiltered);
	resetResults($filterComponent, $items, initialRowsToShow, initialItemsToShow);
	toggleloadMoreButton($items, $filterComponent.find(selectors.loadMoreButton));

	const $noResultsContainer = $filterComponent.find(selectors.noResultsContainer);
	if (numResults === 0) {
		$noResultsContainer.removeClass('hide');
	} else {
		$noResultsContainer.addClass('hide');
	}

	let url = new URL(window.location.href);
	if (activeFilters && activeFilters.length > 0) {
		const id = $filterComponent.attr('id');
		let filtersToIgnore = [];
		activeFilters.forEach(filter => {
			const isGroupCheckbox = $(`#${filter}`)
				.parent()
				.hasClass(classes.checkBoxGroupCheckbox);
			if (isGroupCheckbox) {
				filtersToIgnore = [
					...filtersToIgnore,
					...getActiveFiltersArray($(`#${filter}-groupTag`)),
				];
			}
			if ($(`#${filter}`).data('selectFilters')) {
				filtersToIgnore = [
					...filtersToIgnore,
					...$(`#${filter}`)
						.data('selectFilters')
						.split(',')
						.map(filter => `${$filterComponent.attr('id')}_${filter}`),
				];
			}
		});
		const activeFiltersString = _difference(activeFilters, filtersToIgnore)
			.map(filter => filter.replace(`${id}_`, ''))
			.join(',');
		url.searchParams.set('filters', activeFiltersString);
	} else {
		url.searchParams.delete('filters');
	}
	history.replaceState('', document.title, url.href);
};

const trackAppliedFilters = ($filterComponent, filterId) => {
	let filters_applied = [];
	if (!!$filterComponent.data('trackInteractions')) {
		if (typeof filterId === 'string') {
			filters_applied.push($(`#${filterId}`).data('interactionFilterName'));
		} else {
			const activeFilters = filterId || getActiveFiltersArray($filterComponent);
			filters_applied = activeFilters.map(filter =>
				$(`#${filter}`).data('interactionFilterName')
			);
			filters_applied = filters_applied.filter(interactionFilterName => {
				const [typeName, categoryName] = interactionFilterName.split(':');
				const typeFilterName = `${typeName}:all:all`;
				const categoryFilterName = `${typeName}:${categoryName}:all`;
				const sectionAllIncluded = filters_applied.includes(typeFilterName);
				const parentAllIncluded =
					!sectionAllIncluded && filters_applied.includes(categoryFilterName);

				return (
					interactionFilterName === typeFilterName ||
					(!sectionAllIncluded && interactionFilterName === categoryFilterName) ||
					(!sectionAllIncluded && !parentAllIncluded)
				);
			});
		}
		if (filters_applied.length > 0) {
			window.FS.Tealium.trackLink('apply_filters', {
				filters_applied,
			});
		}
	}
};

const updateShowResultsButton = ($filterComponent, $showResultsButton) => {
	const showResultsTextTemplate = $showResultsButton.data('showResultsTextTemplate');
	const $allItems = $filterComponent.find(selectors.item);
	const $itemsToHide = getItemsToHide($filterComponent, $allItems);
	$showResultsButton
		.find('span')
		.text(showResultsTextTemplate.replace('{0}', $allItems.length - $itemsToHide.length));
};

const updateAllFiltersButton = ($filterComponent, $allFiltersButton) => {
	const activeFilters = getActiveFiltersArray($filterComponent.find(selectors.modal));
	if (activeFilters.length > 0) {
		$allFiltersButton.find(selectors.numFiltersText).text(activeFilters.length);
		$allFiltersButton.addClass(classes.filterButtonActive);
	} else {
		$allFiltersButton.removeClass(classes.filterButtonActive);
	}
};

const setActiveFilter = (
	clickedFilterTag,
	checked,
	fromConnectedFilter = false,
	triggerChange = false
) => {
	const $filter = $(`#${clickedFilterTag}`);
	const $filterComponent = $filter.closest(selectors.filterComponent);

	if (
		$filter.prop('checked') !== checked &&
		$filter.parent().hasClass(classes.checkBoxGroupCheckbox)
	) {
		if (!fromConnectedFilter) {
			$filter.trigger('click');
		} else {
			$filter.prop('checked', checked);
			const $groupContainer = $(`#${clickedFilterTag}-groupTag`);
			const $subcheckboxes = $groupContainer.find(selectors.filterCheckboxInput);
			$subcheckboxes.prop('checked', checked);
		}
	} else {
		$filter.prop('checked', checked);
	}
	if (triggerChange) {
		$filter.trigger('change');
	}

	if ($filter.data('selectFilters')) {
		const isChecked = $filter.prop('checked');
		$filter
			.data('selectFilters')
			.split(',')
			.forEach(filterId => {
				setActiveFilter(`${$filterComponent.attr('id')}_${filterId}`, isChecked, true);
			});
	}

	if ($filter.parent().parent().hasClass(classes.checkBoxGroupCheckboxContainer)) {
		const $groupContainer = $filter.parent().parent();
		const groupId = $groupContainer.attr('id');
		if (groupId) {
			const $subcheckboxesChecked = $groupContainer.find(
				selectors.filterCheckboxInputChecked
			);
			const $subcheckboxes = $groupContainer.find(selectors.filterCheckboxInput);
			if ($subcheckboxesChecked.length === $subcheckboxes.length) {
				$(`#${groupId.replace('-groupTag', '')}`).prop('checked', true);
			} else {
				$(`#${groupId.replace('-groupTag', '')}`).prop('checked', false);
			}
		}
	}

	const $selectFilterFilters = $filterComponent.find('[data-select-filters]');
	$selectFilterFilters.each((i, filter) => {
		const $filterWithSelectFilters = $(filter);
		let filtersToLookFor = [$filter.attr('id')];

		if ($filter.parent().parent().hasClass(classes.checkBoxGroupCheckboxContainer)) {
			const $groupContainer = $filter.parent().parent();
			filtersToLookFor.push($groupContainer.attr('id').replace('-groupTag', ''));
		}
		const filtersToCheck = $filterWithSelectFilters.data('selectFilters').split(',');
		if (
			_intersection(
				filtersToCheck,
				filtersToLookFor.map(filter =>
					filter.replace(`${$filterComponent.attr('id')}_`, '')
				)
			).length > 0
		) {
			let allChecked = true;
			filtersToCheck.forEach(filterId => {
				if (!$(`#${$filterComponent.attr('id')}_${filterId}`).prop('checked')) {
					allChecked = false;
					return;
				}
			});
			$filterWithSelectFilters.prop('checked', $filter.prop('checked') && allChecked);
		}
	});
};

const setQuickFiltersFromChecked = $filterComponent => {
	const activeFilters = getActiveFiltersArray($filterComponent.find(selectors.modal));
	const $quickFilterButtons = $filterComponent.find(selectors.filterButton);
	$quickFilterButtons.removeClass(classes.filterButtonActive);
	$quickFilterButtons.each((i, button) => {
		const $button = $(button);
		if (activeFilters.includes($button.data('filter'))) {
			$button.addClass(classes.filterButtonActive);
		}
	});

	const $quickFilterDropdowns = $filterComponent.find(
		'.WideGridFilter-bar-filterDropdown-container'
	);
	$quickFilterDropdowns.each((i, dropdown) => {
		const $dropdown = $(dropdown);
		const $toggle = $dropdown.find('.WideGridFilter-bar-filterDropdown-button');
		const $dropdownCheckboxes = $dropdown.find('.Checkbox-input');
		$toggle.removeClass(classes.filterButtonActive);
		$dropdownCheckboxes.each((i, checkbox) => {
			const $dropdownCheckbox = $(checkbox);
			const checkboxId = $dropdownCheckbox.attr('id').replace('_quickDropdown', '');
			if (activeFilters.includes(checkboxId)) {
				$toggle.addClass(classes.filterButtonActive);
				return;
			}
		});
	});
};

const setupFilters = $filterComponent => {
	orEverything = $filterComponent.data('filterLogic') === 'OR';
	const $allFilters = $filterComponent.find(selectors.filterCheckboxInput);
	const $showResultsButton = $filterComponent.find(
		`#${$filterComponent.attr('id')}_showResultsButton`
	);
	const $allFiltersButton = $filterComponent.find(selectors.allFiltersButton);

	//Quick Filter Buttons
	$filterComponent
		.find(selectors.filterButton)
		.not(selectors.allFiltersButton)
		.each((i, button) => {
			const $button = $(button);
			$button.on('click', e => {
				//find any showing quick filter dropdowns and hide them
				$filterComponent
					.find('.WideGridFilter-bar-filterDropdown-button--selected')
					.removeClass('WideGridFilter-bar-filterDropdown-button--selected');

				if ($button.hasClass(classes.filterButtonActive)) {
					$button.removeClass(classes.filterButtonActive);
					setActiveFilter($button.data('filter'), false);
				} else {
					$button.addClass(classes.filterButtonActive);
					setActiveFilter($button.data('filter'), true);
					trackAppliedFilters($filterComponent, $button.data('filter'));
				}
				setQuickFiltersFromChecked($filterComponent);
				updateAllFiltersButton($filterComponent, $allFiltersButton);
				triggerFilters($filterComponent);
			});
		});

	//Quick Filter Dropdowns
	$filterComponent.find('.WideGridFilter-bar-filterDropdown-container').each((i, dropdown) => {
		const $dropdown = $(dropdown);
		const id = $dropdown.attr('id');
		const $toggle = $dropdown.find('.WideGridFilter-bar-filterDropdown-button');
		const $clearButton = $dropdown.find(
			'.WideGridFilter-bar-filterDropdown-options-footer-clear'
		);
		const $applyButton = $dropdown.find(
			'.WideGridFilter-bar-filterDropdown-options-footer-apply'
		);
		const $dropdownCheckboxes = $dropdown.find('.Checkbox-input');
		const $overlayBackground = $dropdown.find(
			'.WideGridFilter-bar-filterDropdown-options-background'
		);
		const $closeButton = $dropdown.find(
			'.WideGridFilter-bar-filterDropdown-options-closeButton'
		);

		const toggleDropdownOptions = close => {
			if ($(window).innerWidth() < 961) {
				$('body').css('overflow', close ? '' : 'hidden');
			}

			//add/remove classes as needed
			if (close) {
				$toggle.removeClass('WideGridFilter-bar-filterDropdown-button--selected');
			} else {
				$toggle.addClass('WideGridFilter-bar-filterDropdown-button--selected');
			}
		};

		$toggle.on('click', e => {
			//show or hide options
			if ($toggle.hasClass('WideGridFilter-bar-filterDropdown-button--selected')) {
				toggleDropdownOptions(true);
			} else {
				//find any showing already and hide them
				$filterComponent
					.find('.WideGridFilter-bar-filterDropdown-button--selected')
					.removeClass('WideGridFilter-bar-filterDropdown-button--selected');

				//find the active filters and see if any of these match
				const activeFilters = getActiveFiltersArray($filterComponent.find(selectors.modal));
				$dropdownCheckboxes.each((i, checkbox) => {
					const $dropdownCheckbox = $(checkbox);
					const checkboxId = $dropdownCheckbox.attr('id').replace('_quickDropdown', '');
					$dropdownCheckbox.prop('checked', activeFilters.includes(checkboxId));
				});
				toggleDropdownOptions(false);
			}
			toggleDropdownOptions(
				!$toggle.hasClass('WideGridFilter-bar-filterDropdown-button--selected')
			);
		});

		$clearButton.on('click', e => {
			//it is quick filter, so maybe clear button should also apply on click
			$dropdownCheckboxes.prop('checked', false);
			//update and trigger filters
			$dropdownCheckboxes.each((i, checkbox) => {
				const $dropdownCheckbox = $(checkbox);
				const checkboxId = $dropdownCheckbox.attr('id').replace('_quickDropdown', '');
				setActiveFilter(checkboxId, false);
			});
			updateAllFiltersButton($filterComponent, $allFiltersButton);
			triggerFilters($filterComponent);
			$toggle.removeClass(classes.filterButtonActive);
			toggleDropdownOptions(true);
		});

		$applyButton.on('click', e => {
			//update and trigger filters
			let checkedFilters = [];
			$toggle.removeClass(classes.filterButtonActive);
			$dropdownCheckboxes.each((i, checkbox) => {
				const $dropdownCheckbox = $(checkbox);
				const checkboxId = $dropdownCheckbox.attr('id').replace('_quickDropdown', '');
				setActiveFilter(checkboxId, $dropdownCheckbox.prop('checked'));
				if ($dropdownCheckbox.prop('checked')) {
					checkedFilters.push(checkboxId);
				}
			});
			updateAllFiltersButton($filterComponent, $allFiltersButton);
			triggerFilters($filterComponent);
			trackAppliedFilters($filterComponent, checkedFilters);
			if (checkedFilters.length > 0) {
				$toggle.addClass(classes.filterButtonActive);
			}
			toggleDropdownOptions(true);
		});

		$overlayBackground.on('click', e => {
			toggleDropdownOptions(true);
		});
		$closeButton.on('click', e => {
			toggleDropdownOptions(true);
		});
	});
	//All Filter Checkboxes
	$allFilters.each((i, checkbox) => {
		const $checkbox = $(checkbox);
		$checkbox.on('change', e => {
			setActiveFilter($checkbox.attr('id'), $checkbox.prop('checked'));
			updateShowResultsButton($filterComponent, $showResultsButton);
		});
	});
	//View More Filters
	$filterComponent.find(selectors.viewMoreSectionButton).on('click', e => {
		const $button = $(e.currentTarget);
		const $buttonContainer = $button.parent();
		const $sectionCheckboxes = $buttonContainer.parent().find(selectors.filterCheckbox);
		const viewMoreText = $buttonContainer.data('viewMoreText');
		const viewLessText = $buttonContainer.data('viewLessText');
		if ($button.hasClass('viewLess')) {
			$button.text(viewMoreText);
			$button.removeClass('viewLess');
			$sectionCheckboxes.slice(6).addClass('hide');
		} else {
			$button.text(viewLessText);
			$button.addClass('viewLess');
			$sectionCheckboxes.removeClass('hide');
		}
	});
	//Filter Checkbox Groups
	$filterComponent.find(selectors.checkBoxGroup).each((i, group) => {
		const $group = $(group);
		const $checkboxCarot = $group.find(selectors.checkBoxGroupDropdownCarot);
		const $checkboxInput = $group.find(selectors.checkBoxGroupCheckboxInput);
		const $groupContainer = $group.find(selectors.checkBoxGroupCheckboxContainer);
		const $subcheckboxes = $groupContainer.find(selectors.filterCheckboxInput);
		$checkboxInput.on('click', e => {
			if ($checkboxInput.prop('checked')) {
				$subcheckboxes.prop('checked', true);
			} else {
				$subcheckboxes.prop('checked', false);
			}
			updateShowResultsButton($filterComponent, $showResultsButton);
		});
		$subcheckboxes.on('click', e => {
			const $subcheckboxesChecked = $groupContainer.find(
				selectors.filterCheckboxInputChecked
			);
			if ($subcheckboxesChecked.length === $subcheckboxes.length) {
				$checkboxInput.prop('checked', true);
			} else {
				$checkboxInput.prop('checked', false);
			}
		});
		$checkboxCarot.on('click', e => {
			if ($groupContainer.hasClass('hide')) {
				$group.addClass(classes.checkBoxGroupOpen);
				$groupContainer.removeClass('hide');
			} else {
				$group.removeClass(classes.checkBoxGroupOpen);
				$groupContainer.addClass('hide');
			}
		});
	});

	//Open Modal
	const $modal = $filterComponent.find(`#${$filterComponent.attr('id')}_modal`);
	$allFiltersButton.on('click', e => {
		//find any showing quick filter dropdowns and hide them
		$filterComponent
			.find('.WideGridFilter-bar-filterDropdown-button--selected')
			.removeClass('WideGridFilter-bar-filterDropdown-button--selected');

		updateShowResultsButton($filterComponent, $showResultsButton);
		$modal.data(
			'filtersOnOpen',
			$filterComponent
				.find('.Checkbox-input:checked')
				.map((i, checkbox) => {
					return $(checkbox).attr('id');
				})
				.toArray()
		);
	});

	//Close Modal
	$modal.find(selectors.modalClose).on('click', e => {
		if (e.currentTarget.id === `${$filterComponent.attr('id')}_showResultsButton`) {
			setQuickFiltersFromChecked($filterComponent);
			updateAllFiltersButton($filterComponent, $allFiltersButton);
			triggerFilters($filterComponent);
			trackAppliedFilters($filterComponent);
		} else {
			const filtersToSet = $modal.data('filtersOnOpen');
			$allFilters.each((i, filter) => {
				const filterId = $(filter).attr('id');
				setActiveFilter(filterId, filtersToSet.includes(filterId));
			});
			updateAllFiltersButton($filterComponent, $allFiltersButton);
		}
	});

	//Clear buttons
	$filterComponent.find(`#${$filterComponent.attr('id')}_clearButton`).on('click', e => {
		$filterComponent.find('.Checkbox-input').prop('checked', false);
		updateShowResultsButton($filterComponent, $showResultsButton);
	});
	$filterComponent.find(`#${$filterComponent.attr('id')}_noResultsClearButton`).on('click', e => {
		$filterComponent.find('.Checkbox-input').prop('checked', false);
		setQuickFiltersFromChecked($filterComponent);
		updateAllFiltersButton($filterComponent, $allFiltersButton);
		triggerFilters($filterComponent);
		$modal.data('filtersOnOpen', []);
	});

	//set based on url param
	const filtersUrlParam = new URLSearchParams(window.location.search).get('filters');
	if (filtersUrlParam) {
		const id = $filterComponent.attr('id');
		const activeFiltersOnInit = filtersUrlParam.split(',').map(filter => `${id}_${filter}`);
		activeFiltersOnInit.forEach(filter => {
			if ($filterComponent.has(`#${filter}`)) {
				setActiveFilter(filter, true, !!$(`#${filter}`).data('selectFilters'), true);
			}
		});
		setQuickFiltersFromChecked($filterComponent);
		updateAllFiltersButton($filterComponent, $allFiltersButton);
		triggerFilters($filterComponent);
	}
};

const setupResults = $filterComponent => {
	//setup Load More (button or infinite scroll) (show next X rows)
	setupLoadMore($filterComponent);

	//handle screen size change
	setupOnResize($filterComponent);
};

export default function init() {
	$(selectors.filterComponent).each((i, filterComponent) => {
		setupFilters($(filterComponent));
		setupResults($(filterComponent));
	});
}
